// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"image-carousel"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 3H3V17H21V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M3 13.3636L8.29412 9L18 17H3V13.3636Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M17.5556 7.77778C17.5556 8.75962 16.7596 9.55556 15.7778 9.55556C14.7959 9.55556 14 8.75962 14 7.77778C14 6.79594 14.7959 6 15.7778 6C16.7596 6 17.5556 6.79594 17.5556 7.77778Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 13.7273V13.3636L8.29412 9L18 17M3 3H21V17H3V3ZM17.5556 7.77778C17.5556 8.75962 16.7596 9.55556 15.7778 9.55556C14.7959 9.55556 14 8.75962 14 7.77778C14 6.79594 14.7959 6 15.7778 6C16.7596 6 17.5556 6.79594 17.5556 7.77778Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M3 21H6M10 21H14M18 21L21 21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-image-carousel')
export default class ImageCarouselIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'image-carousel',
    }
  }
}
